// apiClient.js
import axios from "axios";
import storage from "./storageFactory";
const API_BASE_URL = "https://goldfinger.hooverandstrong.com/api";

function userToken() {
  return storage.getStorageItem("authToken");
}

const defaultHeaders = () => {
  const token = userToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 600000,
  headers: defaultHeaders(),
});

export default apiClient;
